/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStarLine: {
  name: 'star-line';
  data: string;
} = {
  name: 'star-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .5.5v7.242l6.303-2.702a.5.5 0 1 1 .394.92L8.814 9.195l4.57 5.485a.5.5 0 1 1-.768.64L8 9.781l-4.616 5.54a.5.5 0 0 1-.768-.641l4.57-5.485L.804 6.46a.5.5 0 1 1 .394-.92L7.5 8.242V1A.5.5 0 0 1 8 .5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
